import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { listLevels } from '../../../api/levels';
import LevelTable from '../../../components/levels/LevelTable';
import PaginationFooter from '../../../components/common/PaginationFooter';
import useSortedClientPagination from '../../../hooks/useSortedClientPagination';
import { levelListSortColumns } from '../../../config/tableSortColumns';
import ListPageLayout, {
    ListPageHeader,
    ListLoadingSpinner,
    ListEmptyState,
    ListTableCard,
} from '../../../components/layout/ListPageLayout';

const CoachLevelList = () => {
    const { t } = useTranslation();
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const [err, setErr] = useState(null);

    useEffect(() => {
        const load = async () => {
            try {
                const res = await listLevels('COACH', { active: true, page: 0, size: 100 });
                setRows(res.data?.content || []);
                setErr(null);
            } catch {
                setErr(t('pages.levels.loadFailed'));
            } finally { setLoading(false); }
        };
        load();
    }, []);

    const pagination = useSortedClientPagination(rows, { columns: levelListSortColumns });

    return (
        <ListPageLayout>
            <ListPageHeader
                title={t('pages.levels.title')}
                subtitle={t('pages.levels.coachSubtitle')}
            />

            {loading ? (
                <ListLoadingSpinner />
            ) : err ? (
                <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg">{err}</div>
            ) : rows.length === 0 ? (
                <ListEmptyState message={t('pages.levels.empty')} />
            ) : (
                <ListTableCard>
                    <LevelTable
                        data={pagination.pageItems}
                        role="COACH"
                        onEdit={() => {}}
                        onArchive={() => {}}
                        sortKey={pagination.sortKey}
                        sortDir={pagination.sortDir}
                        onSort={pagination.toggleSort}
                    />
                </ListTableCard>
            )}

            {rows.length > 0 && (
            <PaginationFooter
                page={pagination.page}
                size={pagination.size}
                total={pagination.total}
                onPageChange={pagination.setPage}
                onSizeChange={pagination.setSize}
            />
            )}
        </ListPageLayout>
    );
};

export default CoachLevelList;
